
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom"; // ✅ importe le router
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      {/* soit tu rends App si tu as plusieurs routes */}
      {/* <App /> */}

      {/* soit directement ta page de connexion */}
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
